import { Popconfirm } from "antd";
import moment from "moment";
import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

import NoTemplateAvailable from "@/Components/Icons/NoTemplateAvailable";
import {
  deleteJobTemplate,
  updateActiveTemplate,
  fetchJobTemplates,
  updateActiveTemplateType,
  updateTemplateLoading,
} from "@/reducers/clientcreatejob";

import SelectTemplateLoading from "./SelectTemplateLoading";
import ActionIcons from "../../ActionIcons";

/**
 * Selects a template and updates the active template.
 *
 * @param {Object} template - The template to be selected
 * @return {void}
 */
export const SelectTemplate = () => {
  const {
    contractTemplates,
    activeTemplate,
    templateIsLoading,
    activeTemplateType = "generic",
  } = useSelector((state) => state.clientCreateJob);

  const { user } = useSelector((state) => state.clientProfile);
  const dispatch = useDispatch();

  // const templateTypes = [
  //   {
  //     name: "Generic",
  //     type: "generic",
  //   },
  //   {
  //     name: "Custom",
  //     type: "custom",
  //   },
  // ]
  /**
   * A function to handle a template click.
   *
   * @param {type} template - the template to be handled
   * @return {type} the result of the template click handling
   */
  const handleTemplateClick = (template) => {
    dispatch(
      updateActiveTemplate({
        template,
      }),
    );
  };

  const handleTemplateType = (type) => {
    if (type == activeTemplateType) {
      return;
    }
    dispatch(updateActiveTemplateType(type));
    dispatch(updateTemplateLoading(true));
    // dispatch(fetchJobTemplates({
    //   type: type
    // }));
    dispatch(fetchJobTemplates());
  };

  const getListTab = (item, index) => {
    return (
      <div
        className={`selectedTemplate_item !z-10 !w-full cursor-pointer select-none rounded-t-lg p-3 text-center text-base font-medium ${activeTemplateType === item.type ? "!font-semibold text-primary" : "text-txtColor"} `}
        key={index}
        onClick={() => handleTemplateType(item.type)}
      >
        {item.name}
      </div>
    );
  };

  return (
    <div className="SelectTemplate_Wrapper">
      <div className="flex flex-col gap-4 rounded-lg bg-white p-4">
        <div className="grid gap-3">
          <h4 className="text-base font-bold leading-[normal] text-black">
            Select Contract Template
          </h4>
          {/* <div className={`grid grid-cols-2  bg-white before:bg-lightblueBG before:border-b-4 before:border-b-primary relative before:content-[''] before:absolute before:top-0 ${activeTemplateType == 'generic' ? 'before:left-0' : 'before:left-1/2'} before:transition-all before:duration-300 before:rounded-t-lg before:ease-linear before:w-1/2 before:bg-lightBlue before:z-0 before:h-full border-b-2 border-b-lightblue`}>
            {
              templateTypes.map((item, index) => {
                return (
                  getListTab(item, index)
                )
              })
            }
          </div> */}
        </div>
        <div className="SubBranchescustom-scrollbar-ui max-h-[26.2rem] overflow-y-auto">
          {templateIsLoading ? (
            Array.from({ length: 5 }).map((_, index) => (
              <Fragment key={index}>
                <SelectTemplateLoading customKey={index} />
              </Fragment>
            ))
          ) : !contractTemplates.length ? (
            <div className="my-7 flex flex-col items-center justify-center gap-3">
              <NoTemplateAvailable />
              <h4 className="select-none text-center text-[14px] font-semibold leading-[normal] text-primary">
                No templates available. <br />
                {activeTemplateType === "generic"
                  ? "Please create Job Rates first to access generic templates."
                  : null}
              </h4>

              {/* {
                    activeTemplateType === "generic" && isPremiumAccount && user?.is_bank_client && clientUserAllPermissions.is_allow_to_bank_jobrates == 1 ?
                      <Link
                        to={routingConstants?.clientJobRates}
                        className="ease relative px-7 rounded-lg border border-primary text-[14px] font-medium leading-[38px] text-primary transition-all duration-200 hover:bg-none  hover:!bg-lightblue hover:text-primary  mt-2"
                      >Go to Job Rates</Link>
                      : null
                  } */}
            </div>
          ) : (
            <ul className="[&>*:last-child]:border-b-0">
              {contractTemplates.map((item, index) => {
                const { id, template_title, updated_at, template_type } = item;
                return (
                  <li
                    className={`ease group flex h-auto items-center justify-between border-b border-b-lightblue px-4 py-2 transition-colors duration-300 hover:bg-lightblue ${activeTemplate?.id === item.id ? "bg-lightblue" : ""}`}
                    key={index}
                    role="button"
                    onClick={(e) => {
                      const isButtonOrChild = e.target.closest("button");
                      if (isButtonOrChild) {
                        return;
                      } else {
                        handleTemplateClick(item);
                      }
                    }}
                  >
                    <div>
                      <h4
                        className={`ease line-clamp-2 text-sm font-semibold capitalize leading-[normal] text-black transition-colors duration-300 group-hover:text-primary ${activeTemplate?.id === item.id ? "text-primary" : ""}`}
                      >
                        {template_title}
                      </h4>
                      {updated_at && (
                        <span
                          className={`ease text-[10px] font-medium text-txtColor transition-colors duration-300 group-hover:text-primary ${activeTemplate?.id === item.id ? "text-primary" : ""}`}
                        >
                          {moment(updated_at).format("DD MMM YYYY")}
                        </span>
                      )}
                    </div>
                    <div className="transition-linear flex gap-2 opacity-0 group-hover:opacity-100">
                      {/* <button className="transition-linear flex h-[30px] w-[30px] items-center justify-center rounded-md bg-white">
                      <ActionIcons type="editPencil" />

                    </button> */}
                      {template_type === "normal" ? (
                        <Popconfirm
                          description={
                            <>
                              <div className="max-w-[300px] p-4">
                                <p className="text-[16px] font-semibold leading-[normal] text-black">
                                  Are you sure you want to delete this template?
                                </p>
                              </div>
                            </>
                          }
                          okButtonProps={{
                            className:
                              "bg-primary text-white border !border-primary hover:!bg-white hover:!text-primary",
                          }}
                          cancelButtonProps={{
                            className:
                              "bg-white text-primary border !border-primary hover:!bg-primary hover:!text-white",
                          }}
                          okText="Yes"
                          cancelText="No"
                          icon={null}
                          // disabled={
                          //     //
                          // }
                          onConfirm={() => {
                            dispatch(
                              deleteJobTemplate({
                                template_id: id,
                              }),
                            );
                            // new Promise((resolve, reject) => {
                            //   dispatch(savejobAsDraft([createJobObj]));
                            //   resolve(); // Resolve the promise after dispatching the action
                            // }).then(() => {
                            //   dispatch(resetPage());
                            // });
                          }}
                        >
                          <button className="transition-linear flex h-[30px] w-[30px] items-center justify-center rounded-md bg-white">
                            <ActionIcons type="delete" />
                          </button>
                        </Popconfirm>
                      ) : null}
                    </div>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
      {/* <EditJobTemplateModal /> */}
    </div>
  );
};
